/* Dr. Zubala - product gallery: thumbnail switch + prev/next arrows + touch swipe. */
(function(){
  if(window.__dzGallery) return; window.__dzGallery=true;
  function init(){
    document.querySelectorAll('[data-dz-gallery]').forEach(function(g){
      var main=g.querySelector('.dz-product-v2__main');
      var mainImg=main?main.querySelector('img'):null;
      var thumbs=Array.prototype.slice.call(g.querySelectorAll('.dz-product-v2__thumb'));
      if(!main||!mainImg||!thumbs.length) return;
      function setActive(i){
        var t=thumbs[i]; if(!t) return;
        var full=t.getAttribute('data-full');
        if(full){ mainImg.removeAttribute('srcset'); mainImg.src=full; mainImg.alt=t.getAttribute('data-alt')||mainImg.alt; }
        thumbs.forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
      }
      thumbs.forEach(function(t,i){ t.addEventListener('click',function(e){e.preventDefault();setActive(i);}); });
      if(thumbs.length<2) return;
      function idx(){ for(var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('is-active')) return i; } return 0; }
      function go(d){ var i=(idx()+d+thumbs.length)%thumbs.length; setActive(i); var t=thumbs[i]; if(t&&t.scrollIntoView) t.scrollIntoView({inline:'center',block:'nearest'}); }
      var prev=document.createElement('button'); prev.type='button'; prev.className='dz-gal-arrow dz-gal-prev'; prev.setAttribute('aria-label','Previous image'); prev.textContent='‹';
      var next=document.createElement('button'); next.type='button'; next.className='dz-gal-arrow dz-gal-next'; next.setAttribute('aria-label','Next image'); next.textContent='›';
      prev.addEventListener('click',function(e){e.preventDefault();go(-1);});
      next.addEventListener('click',function(e){e.preventDefault();go(1);});
      main.appendChild(prev); main.appendChild(next);
      var x0=null;
      main.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
      main.addEventListener('touchend',function(e){ if(x0==null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) go(dx<0?1:-1); x0=null; },{passive:true});
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
